<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h3 class="page-heading">Administration panel</h3>
        <div class="head__users">
          <div class="manage__users">
            <p>Manage Users</p>
          </div>
          <Button v-bind="addButton" @click="openAddUser()" />
        </div>
      </div>
    </div>
    <div>
      <v-card>
        <v-data-table :headers="headers" :items="users" :search="search">
          <template v-slot:items="props">
            <td>
              <div  class="media__image">
                <img
                  v-if="props.item.profileImage"
                  :src="props.item.profileImage"
                  alt="user image"
                />
                <span v-else><i class="far fa-image"></i></span>
              </div>
            </td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
            <td>
              <v-select
                :items="roles"
                item-value="label"
                item-text="label"
                outlined
                v-model="props.item.role"
                @change="updateMemberRole(props.item)"
              >
                <template v-slot:selection="{ item }">
                  <v-tooltip right>
                    <template style="" v-slot:activator="{ on }">
                      <a v-on="on" flat small slot="activator">
                        {{ item.label }}
                      </a>
                    </template>
                    <span>{{ item.title }} </span>
                  </v-tooltip>
                </template>
              </v-select>
            </td>
            <td>
              <v-switch
                v-model="props.item.status"
                @change="changeStatus(props.item)"
              ></v-switch>
            </td>
            <td>{{ props.item.formatedCreatedAt }}</td>
            <td>{{ props.item.formatedUpdatedAt }}</td>
            <td>
              <Button v-bind="remove" @click="removeMember(props.item)" />
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <v-dialog v-model="add_user" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-sm style="padding-top: 0px">
            <h5><i class="fas fa-plus"></i> Add new user</h5>
            <div class="alert alert-danger" role="alert" v-if="errorMessage">
              {{ errorMessage }}
            </div>
            <div class="alert alert-danger" v-if="error">
              {{ error }}
            </div>
            <div class="mt-50">
              <div v-for="(item, index) in elements" :key="index">
                <components
                  :is="item.component"
                  @input="getValue(item.name, item, ...arguments)"
                  v-bind="
                    Object.assign(item, {
                      width: item.component == 'Input' ? null : item.width,
                    })"
                />
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <Button v-bind="saveButton" @click="addUser()" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { db } from "../firebaseDB";
import Button from "../components/global/Button.vue";
import Input from "../components/global/Input.vue";
import moment from "moment";
import Swal from 'sweetalert'

export default {
  components: { Button, Input },
  data() {
    return {
      errorMessage: "",
      users: [],
      search: "",
      headers: [
        { text: "Avatar", value: "profileImage" },
        { text: "User Emails", value: "email" },
        { text: "User Name", value: "name" },
        { text: "Roles", value: "role" },
        { text: "Status", value: "status" },
        { text: "Created", value: "formatedCreatedAt" },
        { text: "Updated", value: "formatedUpdatedAt" },
        { text: "Action", value: "" },
      ],
      email: "",
      password: "",
      add_user: false,
      alert: false,
      addButton: {
        name: "New User",
        backgroundColor: "#1979E7",
        padding: { x: 2, y: 0.7 },
        icon: '<i class="fas fa-plus"></i>',
        iconAfter: true,
      },
      saveButton: {
        name: "Save",
        backgroundColor: "#1979E7",
        padding: { x: 2, y: 0.7 },
        icon: '<i class="fas fa-plus"></i>',
      },
      remove: {
        name: "",
        backgroundColor: "#cd4444",
        padding: { x: 2, y: 0.7 },
        icon: '<i class="fas fa-trash-alt"></i>',
        iconAfter: true,
      },
      elements: [
        {
          label: "E-mail *",
          type: "email",
          hint: "Enter E-mail",
          padding: { x: 0.7, y: 0.5 },
          width: "100%",
          component: "Input",
          name: "email",
        },
        {
          label: "Password *",
          type: "password",
          hint: "Enter Password",
          padding: { x: 0.7, y: 0.5 },
          width: "100%",
          component: "Input",
          name: "password",
        },
      ],
      roles: [
        {
          label: "admin",
          title: "have access to everything",
        },
        {
          label: "creator",
          title: "create projects",
        },
        {
          label: "viewer",
          title: "create projects",
        },
        {
          label: "developer",
          title: "create projects, add assets, support",
        },
      ],
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    console.log(this.$store.state.user);
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    },
  },
  methods: {
    initialize() {
      db.ref(`users`)
        .once("value")
        .then((snapshot) => {
          let temp = [];
          Object.keys(snapshot.val()).forEach((k) => {
            let row = Object.assign(snapshot.val()[k], {
              id: k,
              formatedCreatedAt: snapshot.val()[k].createdAt
                ? moment(snapshot.val()[k].createdAt).format("MMMM Do, YYYY")
                : null,
              formatedUpdatedAt: snapshot.val()[k].updatedAt
                ? moment(snapshot.val()[k].updatedAt).format("MMMM Do, YYYY")
                : null,
            });
            if (
              snapshot.val()[k].email &&
              snapshot.val()[k].email !== this.$store.state.user.email
            ) {
              temp.push(row);
            }
          });
          return temp;
        })
        .catch((error) => {
          console.log("Error - " + error.message);
        })
        .then((snapshot) => {
          this.users = snapshot;
        });
    },
    updateMemberRole(item) {
      let user = {};
      db.ref(`users/` + item.id)
        .once("value")
        .then((snapshot) => {
          user = snapshot.val();
          user.role = item.role;
          user.updatedAt = moment().format("YYYY-MM-DD");
          db.ref(`users/` + item.id)
            .update(user)
            .then((snapshot) => {});
        });
      this.initialize();
    },
    removeMember(item) {
      Swal({
        title: `Do you want to delete this user ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        focusConfirm: false,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (result) {
          db.ref(`users/` + item.id).remove();
          this.initialize();
        }
      });
    },
    getValue(name, item, value) {
      if (name == "email") {
        this.email = value;
      } else if (name == "password") {
        this.password = value;
      }
    },
    openAddUser() {
      this.add_user = true;
    },
    addUser() {
      if (this.email === "" || this.password === "") {
        this.errorMessage = "Please fill all the required fields";
      } else {
        this.errorMessage = "";
        this.$store.dispatch("addUser", {
          email: this.email,
          password: this.password,
        });
        this.initialize();
        this.add_user = false;
      }
    },
    changeStatus(item) {
      let user = {};
      db.ref(`users/` + item.id)
        .once("value")
        .then((snapshot) => {
          user = snapshot.val();
          if (user.status != true) {
            user.status = true;
          } else {
            user.status = false;
          }
          user.updatedAt = moment().format("YYYY-MM-DD");
          db.ref(`users/` + item.id)
            .update(user)
            .then((snapshot) => {});
        });
      this.initialize();
    },
  },
};
</script>
<style  lang="scss" scoped>
.btn {
  margin: 5px;
}
.active {
  background-color: #47b784 !important;
  color: #fff;
}

.btn-toggle {
  top: 50%;
  transform: translateY(-50%);
  background-color: #bdc1c8;
}

.btn-toggle.btn-xs {
  margin: 0 0;
  padding: 0;
  position: relative;
  border: none;
  height: 1rem;
  width: 2rem;
  border-radius: 1rem;
}

.btn-toggle.btn-xs > .handle {
  position: absolute;
  top: 0.125rem;
  left: 0.125rem;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 0.75rem;
  background: #fff;
  transition: left 0.25s;
}

.table-responsive {
  display: inline-table;
}

.mt-50 {
  margin-top: 50px;
}

.theme--light.v-btn {
  background-color: #fff !important;
  color: #47b784 !important;
}

.green {
  border-color: #47b784 !important;
  border: 2px solid;
}
.head__users {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}
.manage__users {
  display: flex;
  align-items: center;
  color: #575555;
  font-weight: 300;
}
.media__image {
        width : 4rem;
        height : 4rem;
        box-shadow:  0 0 1px;
        position : relative;
        background: #fff;
        border-radius: 0.4rem;
        img {
            width : 100%;
            height : 100%;
            object-fit: contain;
        }
        span {
            display:flex;
            align-items: center;
            justify-content: center;
            font-size: 1.9rem;
            color : #a8a8a8;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/AdminPanel.vue